import { useEffect } from "react";
import axios from "axios";
import { useLenis } from "@/hooks/useLenis";
import { initPixel, configurePixel, captureAttribution } from "@/lib/meta";
import { onConsentChange } from "@/lib/consent";
import { LeadModalProvider } from "@/context/LeadModalContext";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { MarginExample } from "@/components/site/MarginExample";
import { StatBar } from "@/components/site/StatBar";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Catalog } from "@/components/site/Catalog";
import { Comparison } from "@/components/site/Comparison";
import { Branding } from "@/components/site/Branding";
import { Positioning } from "@/components/site/Positioning";
import { Vision } from "@/components/site/Vision";
import { WhoFor } from "@/components/site/WhoFor";
import { Scalability } from "@/components/site/Scalability";
import { Credibility } from "@/components/site/Credibility";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { CookieBanner } from "@/components/site/CookieBanner";
import { StickyMobileCTA } from "@/components/site/StickyMobileCTA";
import { LeadModal } from "@/components/site/LeadModal";

export default function Landing() {
  useLenis();

  useEffect(() => {
    captureAttribution();
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`)
      .then(({ data }) => configurePixel(data.meta_pixel_id))
      .catch(() => {})
      .finally(() => initPixel());
    return onConsentChange(() => initPixel());
  }, []);

  return (
    <LeadModalProvider>
      <div className="bg-ivory text-ink overflow-x-hidden">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <HowItWorks />
          <Catalog />
          <Comparison />
          <MarginExample />
          <StatBar />
          <Branding />
          <Positioning />
          <Vision />
          <WhoFor />
          <Scalability />
          <Credibility />
          <FinalCTA />
          <Faq />
        </main>
        <Footer />
        <StickyMobileCTA />
        <CookieBanner />
        <LeadModal />
      </div>
    </LeadModalProvider>
  );
}
